// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import commonCss from './assets/css/common.css'
import commonJs from './assets/js/common'
import './assets/css/iconfont.css'
// 公共组件
import model from './components/myComponents/model'
import modelRight from './components/myComponents/modelRight'
import newHelp from './components/myComponents/newHelp'
import page from './components/myComponents/page'
import cander from './components/myComponents/cander'
import canderYM from './components/myComponents/canderYearMonth'
import canderSFM from './components/myComponents/canderSFM'
import canderReigon from './components/myComponents/canderReigon'
import axiox from './assets/js/axios'
import myCharts from './assets/js/myCharts.js'
import multipleSelect from './components/myComponents/multipleSelect'
import newSelect from './components/myComponents/newSelect'
import imgScorll from './components/myComponents/imgScorll'
import cardScorll from './components/myComponents/cardScorll'
// 自定义组件
import md5 from 'js-md5'
import { Base64 } from 'js-base64'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import {console} from 'vuedraggable/src/util/helper'
let publish = process.env.config
Vue.use(commonCss)
Vue.use(myCharts)
Vue.use(ElementUI)
Vue.component('model', model)
Vue.component('modelRight', modelRight)
Vue.component('imgScorll', imgScorll)
Vue.component('cardScorll', cardScorll)
Vue.component('page', page)
Vue.component('cander', cander)
Vue.component('canderYM', canderYM)
Vue.component('canderSFM', canderSFM)
Vue.component('canderReigon', canderReigon)
Vue.component('newHelp', newHelp)
Vue.component('allSelect', multipleSelect)
Vue.component('newSelect', newSelect)
Vue.prototype.$md5 = md5
Vue.prototype.$Base64 = Base64
Vue.prototype.$commonJs = commonJs
Vue.prototype.$axiox = axiox
Vue.prototype.$baseUrlConfig = publish
// 判断是IE几
let IENum = -1
let userAgent = navigator.userAgent // 取得浏览器的userAgent字符串
console.log(userAgent)
let isIE = userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1 // 判断是否IE<11浏览器
let isChrome = userAgent.indexOf('Chrome') > -1 // 判断是不是谷歌
let isiPad = userAgent.indexOf('iPad') > -1 // 判断是不是ipad
let isEdge = userAgent.indexOf('Edge') > -1 && !isIE // 判断是否IE的Edge浏览器
let isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf('rv:11.0') > -1
if (isIE) {
  let reIE = new RegExp('MSIE (\\d+\\.\\d+);')
  reIE.test(userAgent)
  let fIEVersion = parseFloat(RegExp['$1'])
  if (fIEVersion === 7) {
    IENum = 7
  } else if (fIEVersion === 8) {
    IENum = 8
  } else if (fIEVersion === 9) {
    IENum = 9
  } else if (fIEVersion === 10) {
    IENum = 10
  } else {
    IENum = 6 // IE版本<=7
  }
} else if (isEdge) {
  IENum = 'edge' // edge
} else if (isIE11) {
  IENum = 11 // IE11
} else {
  if (isChrome) {
    IENum = -1 // 是谷歌浏览器内核
  } else {
    IENum = -2 // 不是ie浏览器且不是谷歌
  }
}
Vue.prototype.$IENum = IENum
Vue.prototype.$isiPad = isiPad
// debugger
function getHrefName (name) {
  var href2 = window.location.href.split('?')[1] || ''
  var href = href2.split('#/')[0] || ''
  var hrefArray = href.split('&')
  for (var i = 0; i < hrefArray.length; i++) {
    if (name === hrefArray[i].split('=')[0]) {
      return hrefArray[i].split('=')[1]
    }
  }
}

if (window.location.href.indexOf('thirdlogin') > 0)
{
  window.localStorage.setItem('isthirdlogin', 'true')
  localStorage.gskToken = ''
  localStorage.gskloginInfo = {}
  newVue()
} else if (localStorage.gskToken) {
  //if (self.frameElement && self.frameElement.tagName == "IFRAME") {
  if(window.localStorage.getItem('isthirdlogin') === 'true' ){
        console.log('cedlportal在iframe中')
        getUserInfo()
    }
    else
    {
      console.log('cedlportal不在iframe中')
      newVue()
      router.push('loginHome')
    }

} else if (window.location.href.indexOf('thirdlogin') < 0 && !localStorage.gskToken) {
  newVue()
  router.push('loginHome')
  // localStorage.emailDownId = getHrefName('id')
  // localStorage.emailDownFileName = decodeURIComponent(getHrefName('filename'))
  // window.location.href = publish.ssoUrl
} else {
  newVue()
}

async function getUserInfo () {
  if (!localStorage.gskToken) {
    let gskloginInfo = await axiox.asyncPost('/api/GetUserByCode?code=' + getHrefName('code'))
    if (gskloginInfo) {
      localStorage.gskToken = gskloginInfo.jwtToken
      localStorage.gskloginInfo = JSON.stringify(gskloginInfo)
      GetRoleMenu()
    }
  } else {
    GetRoleMenu()
  }
}
function newVue () {
  // eslint-disable-next-line no-new
  new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
  })
}
function GetRoleMenu () {
  axiox.get('/api/Role/GetRoleMenu').then(msg => {
    let userMenu = msg.data || []
    if (userMenu) {
      let list = []
      let pathList = []
      for (let i = 0; i < userMenu.length; i++) {
        list.push(userMenu[i].name)
        pathList.push(userMenu[i].path)
        for (let j = 0; j < userMenu[i].child.length; j++) {
          list = list.concat(userMenu[i].child[j].cName)
        }
      }
      console.log('userMenu', list)
      console.log('pathList', pathList)
      console.log(list)
      Vue.prototype.$userMenu = list
      Vue.prototype.$pathList = pathList
      if (window.location.href.indexOf('code') >= 0) {
        if (parseInt(localStorage.emailDownId) > 0) {
          router.push({
            name: 'emailDownload'
          })
        } else {
          router.push({
            name: pathList[0] || 'myHome'
          })
        }
      }
      // eslint-disable-next-line no-new
      new Vue({
        el: '#app',
        router,
        components: { App },
        template: '<App/>'
      })
    }
  })
}
// async function initVue () {
//   let userMenu = await axiox.asyncGet('/api/Role/GetRoleMenu')
//   if (userMenu) {
//     let list = []
//     let pathList = []
//     for (let i = 0; i < userMenu.length; i++) {
//       list.push(userMenu[i].name)
//       pathList.push(userMenu[i].path)
//       for (let j = 0; j < userMenu[i].child.length; j++) {
//         list = list.concat(userMenu[i].child[j].cName)
//       }
//     }
//     console.log(userMenu)
//     console.log(pathList)
//     Vue.prototype.$userMenu = list
//     if (window.location.href.indexOf('code') >= 0) {
//       router.push({
//         name: pathList[0] || 'myHome'
//       })
//     }
//   }
//   // eslint-disable-next-line no-new
//   new Vue({
//     el: '#app',
//     router,
//     components: { App },
//     template: '<App/>'
//   })
// }
// eslint-disable-next-line no-new



// WEBPACK FOOTER //
// ./src/main.js